import { sceneApi } from '@/configs/index'
import { baseAjaxErr, addErrorLog } from '@/configs/publicFn'

/* 获取单据详情 */
export const getAgreementDetailsUrl = sceneApi + 'management/1.0/business/findCardsAgreement'
/* 获取临时token */
export const getTemporaryTokenUrl = sceneApi + 'loginapi/1.0/sign/getShortToken'
/* 上传图片 */
export const baseCenterUploadImageUrl = sceneApi + 'aliapi/1.0/oss/baseCenterUploadImage'
/* 提交签署内容 */
export const submitAgreementContentUrl = sceneApi + 'management/1.0/business/updateCardsAgreement'
/* 获取该卡类可消费门店 */
export const getConsumptionShopUrl = sceneApi + 'account/3.0/card/class/query'
/* 获取全部营业中门店列表 */
export const getAllShopListUrl = sceneApi + 'basecenter/1.0/shop/list'

export const getAllShopList = (vm, data) => {
  return new Promise((resolve, reject) => {
    vm.$http.jsonp(getAllShopListUrl, { params: data }).then(res => {
      if (res.data.code === 200) {
        resolve(res.data)
      } else {
        baseAjaxErr(vm, res)
      }
    })
      .catch(err => {
        addErrorLog(err)
        vm.$toast('服务器繁忙，请稍后再试！')
      })
  })
}
export const getConsumptionShop = (vm, data) => {
  return new Promise((resolve, reject) => {
    vm.$http.jsonp(getConsumptionShopUrl, { params: data }).then(res => {
      if (res.data.code === 200) {
        resolve(res.data)
      } else {
        baseAjaxErr(vm, res)
      }
    })
      .catch(err => {
        addErrorLog(err)
        vm.$toast('服务器繁忙，请稍后再试！')
      })
  })
}
export const submitAgreementContent = (vm, data) => {
  return new Promise((resolve, reject) => {
    vm.$http.post(submitAgreementContentUrl, data).then(res => {
      if (res.data.code === 200) {
        resolve(res.data)
      } else {
        baseAjaxErr(vm, res)
      }
    })
      .catch(err => {
        addErrorLog(err)
        vm.$toast('服务器繁忙，请稍后再试！')
      })
  })
}
export const baseCenterUploadImage = (vm, data) => {
  return new Promise((resolve, reject) => {
    vm.$http.post(baseCenterUploadImageUrl, data, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
      if (res.data.code === 200) {
        resolve(res.data)
      } else {
        baseAjaxErr(vm, res)
      }
    })
      .catch(err => {
        addErrorLog(err)
        vm.$Message.error({ content: '服务器繁忙，请稍后再试！', closable: true, duration: 3 })
      })
  })
}
export const getTemporaryToken = (vm, data) => {
  return new Promise((resolve, reject) => {
    vm.$http.jsonp(getTemporaryTokenUrl, { params: data }).then(res => {
      if (res.data.code === 200) {
        resolve(res.data)
      } else {
        baseAjaxErr(vm, res)
      }
    })
      .catch(err => {
        addErrorLog(err)
        vm.$toast('服务器繁忙，请稍后再试！')
      })
  })
}
export const getAgreementDetails = (vm, data) => {
  return new Promise((resolve, reject) => {
    vm.$http.jsonp(getAgreementDetailsUrl, { params: data }).then(res => {
      if (res.data.code === 200) {
        resolve(res.data)
      } else {
        baseAjaxErr(vm, res)
      }
    })
      .catch(err => {
        addErrorLog(err)
        vm.$toast('服务器繁忙，请稍后再试！')
      })
  })
}
